import { createApp } from 'vue';
import { createRouter } from 'vue-router';
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/lib/iconsets/mdi-svg.mjs'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default function(application: VueApplication, elementSelector: string) {
  // Fetch the application configuration
  const instanceConfiguration: InstanceConfiguration = {};

  // Fetch a router if there is one
  if (application.router) {
    
    const router = createRouter({
      ...application.router(),
    });

    instanceConfiguration.router = router;
  }

  // Fetch a store if there is one
  if (application.store) {
    instanceConfiguration.store = application.store();
  }

  // Call back with instanceConfiguration
  if (application.beforeMount) {
    application.beforeMount(instanceConfiguration);
  }

  // Create and mount Vue instance 
  const app = createApp(instanceConfiguration);
  app.config.compilerOptions.whitespace = 'condense'; 

  // Use the store
  if (instanceConfiguration.store){
    app.use(instanceConfiguration.store);
  }

  // Use the router
  if (instanceConfiguration.router) {
    app.use(instanceConfiguration.router);
  }

  // Load all (global) components, etc.
  if (application.initialize) {
    application.initialize(app)
  }

  // use vuetify
  const vuetify = createVuetify({
    components,
    directives,
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
  })
  app.use(vuetify)

  app.mount(elementSelector);
}
